export class SortExpressionPlainObject {
    public ascending: boolean;

    public nullsFirst: boolean;

    public expression: string;
}
